import Sprite from "app/components/sprite";
import { Trans } from "react-i18next";

export const ValuesSection = () => {
  return (
    <section
      className="relative overflow-hidden
    bg-ghostwhite ltr:h-[1250px] rtl:h-[1100px] md:h-[1100px]
      ltr:lg:h-[805px] rtl:lg:h-[700px] rtl:xl:h-[800px]"
    >
      <div className="h-full py-2">
        <div className="zbooni-layout relative h-full w-full">
          <div
            className="relative z-[2] flex w-full
            flex-col items-center justify-center px-3 font-montserrat
            leading-6 text-primary ltr:h-full xs:px-10 sm:px-14 lg:grid
            lg:grid-cols-3 lg:justify-between lg:py-20 xl:px-32 xl:py-28"
          >
            <div
              className="item-center flex flex-col py-6
              md:justify-between lg:h-full lg:py-2"
            >
              <div
                className="flex max-w-[300px] flex-col
                items-center justify-center pb-2 rtl:pt-6
                lg:pb-0 xl:max-w-[345px]"
              >
                <Sprite name="eye" className="h-[80px] w-[140px]" />
                <p
                  className="pb-2 text-center
                  text-3xl font-extrabold lg:pb-4"
                >
                  <Trans>Our Vision</Trans>
                </p>
                <p className="pb-10 text-center text-base font-medium">
                  <Trans>
                    Enabling exceptional personalized commerce experiences for
                    businesses and their customers.
                  </Trans>
                </p>
                <hr className="block w-[350px] border-black lg:hidden" />
              </div>
              <div
                className="flex max-w-[300px] flex-col items-center 
                justify-center pb-2 pt-6 lg:pb-0 xl:max-w-[345px]"
              >
                <Sprite name="dart" className="h-[90px] w-[160px]" />
                <p
                  className="pb-2 text-center
                  text-3xl font-extrabold lg:pb-4"
                >
                  <Trans>Our Mission</Trans>
                </p>
                <p className="pb-10 text-center text-base font-medium">
                  <Trans>Empowering the next generation of commerce.</Trans>
                </p>
                <hr className="block w-[350px] border-black lg:hidden" />
              </div>
            </div>
            <div className="flex flex-col items-center justify-center">
              <Sprite
                name="aboutus-line"
                className="hidden h-[500px]
                  w-[5px] lg:block"
              />
            </div>
            <div>
              <div
                className="flex h-full flex-col items-center 
                justify-center pt-4 lg:py-2 lg:pt-0"
              >
                <Sprite name="aboutus-diamond" className="h-[60px] w-[70px]" />
                <p
                  className="pb-3 text-center
                  text-3xl font-extrabold lg:pb-8"
                >
                  <Trans>Our Values</Trans>
                </p>
                <div className="flex flex-col">
                  <div className="pb-6">
                    <div
                      className="flex w-full flex-1 flex-col
                      items-center justify-center"
                    >
                      <p className="pb-1 text-center font-bold">
                        <Trans>Have compassion</Trans>
                      </p>
                      <p
                        className="text-center text-sm
                        font-normal sm:max-w-[370px] md:w-full"
                      >
                        <Trans>
                          Be human and treat everyone with care and respect
                          without discrimination. Stay mindful of people around
                          you and what matters to them. Handle every customer’s
                          business like it’s your own.
                        </Trans>
                      </p>
                    </div>
                  </div>
                  <div className="pb-6">
                    <div
                      className="flex w-full flex-1 flex-col
                      items-center justify-center"
                    >
                      <p className="pb-1 text-center font-bold">
                        <Trans>Create impact</Trans>
                      </p>
                      <p
                        className="text-center text-sm
                        font-normal sm:max-w-[370px] md:w-full"
                      >
                        <Trans>
                          Make a difference through your words and/or actions.
                          Raise your voice when you witness injustice or
                          prejudice. Be an agent of change for the better in
                          your personal and professional life.
                        </Trans>
                      </p>
                    </div>
                  </div>
                  <div className="pb-6">
                    <div
                      className="flex w-full flex-1 flex-col
                      items-center justify-center"
                    >
                      <p className="pb-1 text-center font-bold">
                        <Trans>Keep growing</Trans>
                      </p>
                      <p
                        className="text-center text-sm
                        font-normal sm:max-w-[370px] md:w-full"
                      >
                        <Trans>
                          Keep yourself informed about your environment and the
                          world we live in. Nurture your innovative mind and
                          strive to stay ahead. Support others in their personal
                          and professional development.
                        </Trans>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
